export const generateTenantModel = () => ({
  name: '',
  shortName: '',
  azureTenantBody: '',
  azureAppTenantBody: '',
});
